// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/integrations.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/integrations.proto.
 */
export const file_cortado_v1_integrations: GenFile = /*@__PURE__*/
  fileDesc("Ch1jb3J0YWRvL3YxL2ludGVncmF0aW9ucy5wcm90bxIKY29ydGFkby52MSKNAgoXT3JnYW5pemF0aW9uSW50ZWdyYXRpb24SCgoCaWQYASABKAkSFwoPb3JnYW5pemF0aW9uX2lkGAIgASgJEhgKEGludGVncmF0aW9uX3R5cGUYAyABKAkSMAoMY29ubmVjdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIcChRjb25uZWN0ZWRfYnlfdXNlcl9pZBgFIAEoCRIVCg1tZXRhZGF0YV9qc29uGAYgASgJEjgKD2Rpc2Nvbm5lY3RlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBAUISChBfZGlzY29ubmVjdGVkX2F0IlYKIUdldE9yZ2FuaXphdGlvbkludGVncmF0aW9uUmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkSGAoQaW50ZWdyYXRpb25fdHlwZRgCIAEoCSJzCiJHZXRPcmdhbml6YXRpb25JbnRlZ3JhdGlvblJlc3BvbnNlEj0KC2ludGVncmF0aW9uGAEgASgLMiMuY29ydGFkby52MS5Pcmdhbml6YXRpb25JbnRlZ3JhdGlvbkgAiAEBQg4KDF9pbnRlZ3JhdGlvbiJwCiRVcHNlcnRPcmdhbml6YXRpb25JbnRlZ3JhdGlvblJlcXVlc3QSFwoPb3JnYW5pemF0aW9uX2lkGAEgASgJEhgKEGludGVncmF0aW9uX3R5cGUYAiABKAkSFQoNbWV0YWRhdGFfanNvbhgDIAEoCSJhCiVVcHNlcnRPcmdhbml6YXRpb25JbnRlZ3JhdGlvblJlc3BvbnNlEjgKC2ludGVncmF0aW9uGAEgASgLMiMuY29ydGFkby52MS5Pcmdhbml6YXRpb25JbnRlZ3JhdGlvbiJdCihEaXNjb25uZWN0T3JnYW5pemF0aW9uSW50ZWdyYXRpb25SZXF1ZXN0EhcKD29yZ2FuaXphdGlvbl9pZBgBIAEoCRIYChBpbnRlZ3JhdGlvbl90eXBlGAIgASgJIkEKKURpc2Nvbm5lY3RPcmdhbml6YXRpb25JbnRlZ3JhdGlvblJlc3BvbnNlEhQKDGRpc2Nvbm5lY3RlZBgBIAEoCCI8CgxTbGFja0NoYW5uZWwSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRISCgppc19wcml2YXRlGAMgASgIIjMKGExpc3RTbGFja0NoYW5uZWxzUmVxdWVzdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkiRwoZTGlzdFNsYWNrQ2hhbm5lbHNSZXNwb25zZRIqCghjaGFubmVscxgBIAMoCzIYLmNvcnRhZG8udjEuU2xhY2tDaGFubmVsIjsKIEdldENvbm5lY3RlZFNsYWNrQ2hhbm5lbHNSZXF1ZXN0EhcKD29yZ2FuaXphdGlvbl9pZBgBIAEoCSI4CiFHZXRDb25uZWN0ZWRTbGFja0NoYW5uZWxzUmVzcG9uc2USEwoLY2hhbm5lbF9pZHMYASADKAkiUAogU2V0Q29ubmVjdGVkU2xhY2tDaGFubmVsc1JlcXVlc3QSFwoPb3JnYW5pemF0aW9uX2lkGAEgASgJEhMKC2NoYW5uZWxfaWRzGAIgAygJIjQKIVNldENvbm5lY3RlZFNsYWNrQ2hhbm5lbHNSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIQiZaJGh1Yi1iYWNrZW5kL2dlbi9jb3J0YWRvL3YxO2NvcnRhZG92MWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message cortado.v1.OrganizationIntegration
 */
export type OrganizationIntegration = Message<"cortado.v1.OrganizationIntegration"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string integration_type = 3;
   */
  integrationType: string;

  /**
   * @generated from field: google.protobuf.Timestamp connected_at = 4;
   */
  connectedAt?: Timestamp;

  /**
   * @generated from field: string connected_by_user_id = 5;
   */
  connectedByUserId: string;

  /**
   * @generated from field: string metadata_json = 6;
   */
  metadataJson: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp disconnected_at = 7;
   */
  disconnectedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.OrganizationIntegration.
 * Use `create(OrganizationIntegrationSchema)` to create a new message.
 */
export const OrganizationIntegrationSchema: GenMessage<OrganizationIntegration> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 0);

/**
 * @generated from message cortado.v1.GetOrganizationIntegrationRequest
 */
export type GetOrganizationIntegrationRequest = Message<"cortado.v1.GetOrganizationIntegrationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string integration_type = 2;
   */
  integrationType: string;
};

/**
 * Describes the message cortado.v1.GetOrganizationIntegrationRequest.
 * Use `create(GetOrganizationIntegrationRequestSchema)` to create a new message.
 */
export const GetOrganizationIntegrationRequestSchema: GenMessage<GetOrganizationIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 1);

/**
 * @generated from message cortado.v1.GetOrganizationIntegrationResponse
 */
export type GetOrganizationIntegrationResponse = Message<"cortado.v1.GetOrganizationIntegrationResponse"> & {
  /**
   * @generated from field: optional cortado.v1.OrganizationIntegration integration = 1;
   */
  integration?: OrganizationIntegration;
};

/**
 * Describes the message cortado.v1.GetOrganizationIntegrationResponse.
 * Use `create(GetOrganizationIntegrationResponseSchema)` to create a new message.
 */
export const GetOrganizationIntegrationResponseSchema: GenMessage<GetOrganizationIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 2);

/**
 * @generated from message cortado.v1.UpsertOrganizationIntegrationRequest
 */
export type UpsertOrganizationIntegrationRequest = Message<"cortado.v1.UpsertOrganizationIntegrationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string integration_type = 2;
   */
  integrationType: string;

  /**
   * @generated from field: string metadata_json = 3;
   */
  metadataJson: string;
};

/**
 * Describes the message cortado.v1.UpsertOrganizationIntegrationRequest.
 * Use `create(UpsertOrganizationIntegrationRequestSchema)` to create a new message.
 */
export const UpsertOrganizationIntegrationRequestSchema: GenMessage<UpsertOrganizationIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 3);

/**
 * @generated from message cortado.v1.UpsertOrganizationIntegrationResponse
 */
export type UpsertOrganizationIntegrationResponse = Message<"cortado.v1.UpsertOrganizationIntegrationResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationIntegration integration = 1;
   */
  integration?: OrganizationIntegration;
};

/**
 * Describes the message cortado.v1.UpsertOrganizationIntegrationResponse.
 * Use `create(UpsertOrganizationIntegrationResponseSchema)` to create a new message.
 */
export const UpsertOrganizationIntegrationResponseSchema: GenMessage<UpsertOrganizationIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 4);

/**
 * @generated from message cortado.v1.DisconnectOrganizationIntegrationRequest
 */
export type DisconnectOrganizationIntegrationRequest = Message<"cortado.v1.DisconnectOrganizationIntegrationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string integration_type = 2;
   */
  integrationType: string;
};

/**
 * Describes the message cortado.v1.DisconnectOrganizationIntegrationRequest.
 * Use `create(DisconnectOrganizationIntegrationRequestSchema)` to create a new message.
 */
export const DisconnectOrganizationIntegrationRequestSchema: GenMessage<DisconnectOrganizationIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 5);

/**
 * @generated from message cortado.v1.DisconnectOrganizationIntegrationResponse
 */
export type DisconnectOrganizationIntegrationResponse = Message<"cortado.v1.DisconnectOrganizationIntegrationResponse"> & {
  /**
   * @generated from field: bool disconnected = 1;
   */
  disconnected: boolean;
};

/**
 * Describes the message cortado.v1.DisconnectOrganizationIntegrationResponse.
 * Use `create(DisconnectOrganizationIntegrationResponseSchema)` to create a new message.
 */
export const DisconnectOrganizationIntegrationResponseSchema: GenMessage<DisconnectOrganizationIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 6);

/**
 * @generated from message cortado.v1.SlackChannel
 */
export type SlackChannel = Message<"cortado.v1.SlackChannel"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool is_private = 3;
   */
  isPrivate: boolean;
};

/**
 * Describes the message cortado.v1.SlackChannel.
 * Use `create(SlackChannelSchema)` to create a new message.
 */
export const SlackChannelSchema: GenMessage<SlackChannel> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 7);

/**
 * @generated from message cortado.v1.ListSlackChannelsRequest
 */
export type ListSlackChannelsRequest = Message<"cortado.v1.ListSlackChannelsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListSlackChannelsRequest.
 * Use `create(ListSlackChannelsRequestSchema)` to create a new message.
 */
export const ListSlackChannelsRequestSchema: GenMessage<ListSlackChannelsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 8);

/**
 * @generated from message cortado.v1.ListSlackChannelsResponse
 */
export type ListSlackChannelsResponse = Message<"cortado.v1.ListSlackChannelsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.SlackChannel channels = 1;
   */
  channels: SlackChannel[];
};

/**
 * Describes the message cortado.v1.ListSlackChannelsResponse.
 * Use `create(ListSlackChannelsResponseSchema)` to create a new message.
 */
export const ListSlackChannelsResponseSchema: GenMessage<ListSlackChannelsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 9);

/**
 * @generated from message cortado.v1.GetConnectedSlackChannelsRequest
 */
export type GetConnectedSlackChannelsRequest = Message<"cortado.v1.GetConnectedSlackChannelsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetConnectedSlackChannelsRequest.
 * Use `create(GetConnectedSlackChannelsRequestSchema)` to create a new message.
 */
export const GetConnectedSlackChannelsRequestSchema: GenMessage<GetConnectedSlackChannelsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 10);

/**
 * @generated from message cortado.v1.GetConnectedSlackChannelsResponse
 */
export type GetConnectedSlackChannelsResponse = Message<"cortado.v1.GetConnectedSlackChannelsResponse"> & {
  /**
   * @generated from field: repeated string channel_ids = 1;
   */
  channelIds: string[];
};

/**
 * Describes the message cortado.v1.GetConnectedSlackChannelsResponse.
 * Use `create(GetConnectedSlackChannelsResponseSchema)` to create a new message.
 */
export const GetConnectedSlackChannelsResponseSchema: GenMessage<GetConnectedSlackChannelsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 11);

/**
 * @generated from message cortado.v1.SetConnectedSlackChannelsRequest
 */
export type SetConnectedSlackChannelsRequest = Message<"cortado.v1.SetConnectedSlackChannelsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: repeated string channel_ids = 2;
   */
  channelIds: string[];
};

/**
 * Describes the message cortado.v1.SetConnectedSlackChannelsRequest.
 * Use `create(SetConnectedSlackChannelsRequestSchema)` to create a new message.
 */
export const SetConnectedSlackChannelsRequestSchema: GenMessage<SetConnectedSlackChannelsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 12);

/**
 * @generated from message cortado.v1.SetConnectedSlackChannelsResponse
 */
export type SetConnectedSlackChannelsResponse = Message<"cortado.v1.SetConnectedSlackChannelsResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message cortado.v1.SetConnectedSlackChannelsResponse.
 * Use `create(SetConnectedSlackChannelsResponseSchema)` to create a new message.
 */
export const SetConnectedSlackChannelsResponseSchema: GenMessage<SetConnectedSlackChannelsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_integrations, 13);

